export interface GeneratedTextItem {
  id: string;
  title: string;
  content: string;
  preset_name: string;
  provider: string;
  model: string;
  user_input: string;
  sort_order: number;
  created_at: number;
  updated_at: number;
}

const BASE = '/api/generated-texts';

export async function fetchAllGeneratedTexts(): Promise<GeneratedTextItem[]> {
  try {
    const res = await fetch(BASE, { cache: 'no-store' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return (await res.json()) as GeneratedTextItem[];
  } catch (e) {
    console.error('fetchAllGeneratedTexts failed:', e);
    return [];
  }
}

export async function createGeneratedTextRequest(params: {
  id: string;
  title: string;
  content: string;
  presetName: string;
  provider: string;
  model: string;
  userInput: string;
}): Promise<GeneratedTextItem | null> {
  try {
    const res = await fetch(BASE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return (await res.json()) as GeneratedTextItem;
  } catch (e) {
    console.error('createGeneratedTextRequest failed:', e);
    return null;
  }
}

export async function updateGeneratedTextRequest(
  id: string,
  title: string,
  content: string,
): Promise<boolean> {
  try {
    const res = await fetch(BASE, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, title, content }),
    });
    return res.ok;
  } catch (e) {
    console.error('updateGeneratedTextRequest failed:', e);
    return false;
  }
}

export async function updateGeneratedTextOrderRequest(
  orders: { id: string; sort_order: number }[],
): Promise<boolean> {
  try {
    const res = await fetch(BASE, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orders }),
    });
    return res.ok;
  } catch (e) {
    console.error('updateGeneratedTextOrderRequest failed:', e);
    return false;
  }
}

export async function deleteGeneratedTextRequest(id: string): Promise<boolean> {
  try {
    const res = await fetch(BASE, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id }),
    });
    return res.ok;
  } catch (e) {
    console.error('deleteGeneratedTextRequest failed:', e);
    return false;
  }
}
